<div class="flex h-full items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-vat-image-2 bg-cover">
  <div class="shadow-xl">
    <div class="bg-white px-8 py-8 rounded-lg bg-opacity-80 shadow-md">

      <div *ngIf="validToken; else expiredTokenTpl"  class="max-w-lg   w-80">

        <div class="flex justify-center pb-4 border-b border-blue-500">
          <svg-icon src="assets/svg/logo.svg" svgClass="h-16"></svg-icon>
        </div>


        <div class="mt-4">
          <h2 class="text-center  text-3xl leading-9 font-thin text-blue-500">
             Create your new account
          </h2>
        </div>
        <form [formGroup]="form" class="mt-8" (submit)="onSubmit()">

          <div class="grid grid-cols-1 gap-6">

            <app-form-field #firstName="formField" inputId="firstName" class="required" label="First Name">
              <input appInput [formControlName]="firstName.inputId" [name]="firstName.inputId" [id]="firstName.inputId" type="text"
                    [class.border-red-800]="form.controls.firstName?.invalid && form.controls.firstName?.touched"/>
                    <p *ngIf="form.controls.firstName.errors?.required && form.controls.firstName?.touched" class="mt-2 block text-xs text-red-600">Missing first name.</p>

            </app-form-field>

            <app-form-field #lastName="formField" inputId="lastName" class="required" label="Last Name">
              <input appInput [formControlName]="lastName.inputId" [name]="lastName.inputId" [id]="lastName.inputId" type="text"
                    [class.border-red-800]="form.controls.lastName?.invalid && form.controls.lastName?.touched"/>
                    <p *ngIf="form.controls.lastName.errors?.required && form.controls.lastName?.touched" class="mt-2 block text-xs text-red-600">Missing last name.</p>

            </app-form-field>

            <app-form-field #password="formField" inputId="password" class="required" label="Password">
              <input appInput [formControlName]="password.inputId" [name]="password.inputId" [id]="password.inputId" type="password"
                    [class.border-red-800]="form.controls.password?.invalid && form.controls.password?.touched"/>
              <p [class.text-red-600]="form.controls.password.errors?.pattern && form.controls.password.touched"
                    class="mt-2 text-xs text-gray-400">Password must be between 8 to 32 characters with at least 1 uppercase,
                   1 lower case and 1 number.</p>
                   <p *ngIf="form.controls.password.errors?.required && form.controls.password?.touched" class="mt-2 block text-xs text-red-600">Missing password.</p>

            </app-form-field>

            <app-form-field #verifyPassword="formField" inputId="verifyPassword" class="required" label="Repeat Password">
              <input appInput [formControlName]="verifyPassword.inputId" [name]="verifyPassword.inputId" [id]="verifyPassword.inputId" type="password"
                    [class.border-red-800]="form.controls.verifyPassword  ?.invalid && form.controls.verifyPassword?.touched"/>
                    <p *ngIf="form.controls.verifyPassword.errors?.required && form.controls.verifyPassword?.touched" class="mt-2 block text-xs text-red-600">Missing password verification.</p>

            </app-form-field>

          </div>

          <!-- <div *ngFor="let c of form.value | keyvalue" > {{ form.controls[c.key].errors?.required && form.controls[c.key]?.touched }} </div> -->


          <div class="mt-8"></div>

          <!-- <div *ngIf="form.invalid && form.touched" class="rounded-md bg-red-50 p-2 mt-4">

                <div class="mt-2 text-sm text-red-700">
                  <ul role="list" class="list-disc pl-5 space-y-1">
                    <li *ngIf="form.controls.password.errors?.required && form.controls.password?.touched" class="mt-2 block text-xs text-red-600">Missing password.</li>
                    <li *ngIf="form.controls.verifyPassword.errors?.required && form.controls.verifyPassword?.touched" class="mt-2 block text-xs text-red-600">Missing password verification.</li>
                  </ul>
                </div>


          </div> -->

          <div class="mt-2">
            <button type="submit" [disabled]="form.invalid || loading"
                                  [class.opacity-50]="form.invalid"
                                  [class.hover:bg-yellow-500]="form.valid" class="group relative w-full  flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-secondary focus:outline-none focus:border-yellow-600 focus:shadow-outline-yellow active:bg-yellow-600 transition duration-150 ease-in-out">
                <svg *ngIf="loading; else notLoading" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <ng-template #notLoading>
                  Submit
                </ng-template>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<ng-template #expiredTokenTpl>
  <div>
    <div class="flex justify-center pb-4 border-b border-blue-500">
      <svg-icon src="assets/svg/logo.svg" svgClass="h-16"></svg-icon>
    </div>
    <p class="mt-8 text-lg text-primary font-light max-w-md text-center"> Invitation is no longer valid, please contact your administrator to send a new Invitation. </p>
  </div>
</ng-template>


